/** Which edges of a horizontally scrollable strip currently hide content. */
export interface RailFadeEdges {
  left: boolean;
  right: boolean;
}

/**
 * A side should only fade when that side actually has hidden content: the left edge once the
 * strip has scrolled past its start, the right edge while there is more to scroll to. Guards
 * against the phone decade rail fading its first or last chip when nothing overflows.
 */
export function railFadeEdges({
  scrollLeft,
  clientWidth,
  scrollWidth,
}: {
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
}): RailFadeEdges {
  return {
    left: scrollLeft > 0,
    right: scrollLeft + clientWidth < scrollWidth - 1,
  };
}
